// src/pages/ProductContext.js
import React, { createContext, useState, useContext, useEffect } from "react";
import assets from "../assets/assets";

const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  // Oppdatert produktdata med en 'gallery'-property for hvert produkt
  const [products] = useState([
    {
      id: 1,
      name: "Elegant Benk",
      price: 5700,
      imageUrl: assets.benk.b5,
      description: "Dette er en nydelig benk i valnøtt",
      gallery: [
        assets.benk.b1,
        assets.benk.b2,
        assets.benk.b3,
        assets.benk.b4,
        assets.benk.b6,
        assets.benk.b7,
        assets.benk.b5,
      ]
    },
    {
      id: 2,
      name: "Enkelt kaffebord",
      price: 3000,
      imageUrl: assets.coffetable.coffetableImage,
      description: "Enkelt kaffebord i gjenbrukt teak - laget av gammelt utebord",
      gallery: [
        assets.coffetable.coffetableImage,
      ]
    },
    {
      id: 3,
      name: "Stuebord",
      price: 9500,
      imageUrl: assets.roundtable.roundtableImage,
      description: "Ovalt stuebord laget i ask",
      gallery: [
        assets.roundtable.roundtableImage,
        assets.roundtableImages.lrt1,
        assets.roundtableImages.lrt2,
        assets.roundtableImages.lrt3,
        assets.roundtableImages.lrt4,
        assets.roundtableImages.lrt5,
        assets.roundtableImages.lrt6,
        assets.videos.rmovie,
      ]
    },
    {
      id: 4,
      name: "Klapp krakk",
      price: 5700,
      imageUrl: assets.flip.f11,
      description: "A beautiful wooden bench made of",
      gallery: [
        assets.flip.f1,
        assets.flip.f2,
        assets.flip.f3,
        assets.flip.f4,
        assets.flip.f5,
        assets.flip.f6,
        assets.flip.f7,
        assets.flip.f8,
        assets.flip.f9,
        assets.flip.f10,
        assets.flip.f11,
      ]
    },
    {
      id: 5,
      name: "To trinns krakk",
      price: 7200,
      imageUrl: assets.stool.ss7,
      description: "En praktisk og vakker krakk i ask.",
      gallery: [
        assets.stool.ss1,
        assets.stool.ss2,
        assets.stool.ss3,
        assets.stool.ss4,
        assets.stool.ss5,
        assets.stool.ss6,
        assets.stool.ss7,
      ]
    },
    {
      id: 6,
      name: "Trefjøl",
      price: 1700,
      imageUrl: assets.fjol.fj1,
      description: "Treverk av høy kvalitet.",
      gallery: [
        assets.fjol.fj1,
        assets.fjol.fj2,
        assets.fjol.fj3,
        assets.fjol.fj4,
        assets.fjol.fj5,
      ]
    },
    {
      id: 7,
      name: "TV benk",
      price: 1700,
      imageUrl: assets.tvstand.t12,
      description: "Fin romslig tv-benk i valnøtt for bøker og audiovisuelt utstyr.",
      gallery: [
        assets.tvstand.t1,
        assets.tvstand.t2,
        assets.tvstand.t3,
        assets.tvstand.t4,
        assets.tvstand.t5,
        assets.tvstand.t6,
        assets.tvstand.t7,
        assets.tvstand.t8,
        assets.tvstand.t9, // Pass på at t9 er definert i assets-modulen
        assets.tvstand.t10,
        assets.tvstand.t11,
        assets.tvstand.t12,
        assets.tvstand.t13,
      ]
    },
    {
      id: 8,
      name: "Nattbord",
      price: 1700,
      imageUrl: assets.nattbord.n12,
      description: "Vegghengt nattbord med fransk list(French cleat) for enkel montering.",
      gallery: [
        assets.nattbord.n1,
        assets.nattbord.n2,
        assets.nattbord.n3,
        assets.nattbord.n4,
        assets.nattbord.n5,
        assets.nattbord.n6,
        assets.nattbord.n7,
        assets.nattbord.n8,
        assets.nattbord.n9,
        assets.nattbord.n10,
        assets.nattbord.n11,
        assets.nattbord.n12,
        assets.nattbord.n13,
      ]
    },
    {
      id: 9,
      name: "Rundt bord i valnøtt",
      price: 1700,
      imageUrl: assets.roundtableExtra.rt8,
      description: "Rundt bord i valnøtt med enkle linjer og en vakker finish.",
      gallery: [
        assets.roundtableExtra.rt1,
        assets.roundtableExtra.rt2,
        assets.roundtableExtra.rt3,
        assets.roundtableExtra.rt4,
        assets.roundtableExtra.rt5,
        assets.roundtableExtra.rt6,
        assets.roundtableExtra.rt7,
        assets.roundtableExtra.rt8,
        assets.videos.rturn,
      ]
    },
    {
      id: 10,
      name: "Solid spisestue",
      price: 1700,
      imageUrl: assets.spisestuebord.s18,
      description: "Et solid spisestuebord laget i ask.",
      gallery: [
        assets.spisestuebord.s1,
        assets.spisestuebord.s2,
        assets.spisestuebord.s3,
        assets.spisestuebord.s4,
        assets.spisestuebord.s5,
        assets.spisestuebord.s6,
        assets.spisestuebord.s7,
        assets.spisestuebord.s8,
        assets.spisestuebord.s9,
        assets.spisestuebord.s10,
        assets.spisestuebord.s11,
        assets.spisestuebord.s12,
        assets.spisestuebord.s13,
        assets.spisestuebord.s14,
        assets.spisestuebord.s15,
        assets.spisestuebord.s16,
        assets.spisestuebord.s17,
        assets.spisestuebord.s18,
      ]
    },
    {
      id: 11,
      name: "Gyngestol",
      price: 1700,
      imageUrl: assets.swing.lr0016,
      description: "En deilig avslappende stol",
      gallery: [
        assets.swing.lr0001,
        assets.swing.lr0002,
        assets.swing.lr0003,
        assets.swing.lr0004,
        assets.swing.lr0005,
        assets.swing.lr0006,
        assets.swing.lr0007,
        assets.swing.lr0008,
        assets.swing.lr0009,
        assets.swing.lr0010,
        assets.swing.lr0011,
        assets.swing.lr0012,
        assets.swing.lr0013,
        assets.swing.lr0014,
        assets.swing.lr0015,
        assets.swing.lr0016,
      ]
    },
  ]);

  // Hent handlekurv fra localStorage
  const [cartItems, setCartItems] = useState(() => {
    return JSON.parse(localStorage.getItem("cart")) || [];
  });

  // Oppdater localStorage når handlekurven endres
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cartItems));
  }, [cartItems]);

  // Legg til produkt i handlekurven
  const addToCart = (product) => {
    setCartItems((prevCart) => {
      const productIndex = prevCart.findIndex((item) => item.id === product.id);
      if (productIndex !== -1) {
        const updatedCart = [...prevCart];
        updatedCart[productIndex] = {
          ...updatedCart[productIndex],
          quantity: updatedCart[productIndex].quantity + 1,
        };
        return updatedCart;
      } else {
        return [...prevCart, { ...product, quantity: 1 }];
      }
    });
  };

  // Funksjon for å redusere antall produkter i handlekurven
  const decreaseQuantity = (productId) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === productId
          ? { ...item, quantity: Math.max(1, item.quantity - 1) }
          : item
      )
    );
  };

  // Funksjon for å fjerne et produkt fra handlekurven
  const removeFromCart = (productId) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.id !== productId));
  };

  return (
    <ProductContext.Provider
      value={{ cartItems, addToCart, decreaseQuantity, removeFromCart, products }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export const useProducts = () => useContext(ProductContext);